module.exports = "<app-matricules></app-matricules>\r\n"